"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionIconButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ActionIconButton(_ref) {
  let {
    title,
    onAction,
    busy = false,
    disabled = false,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !busy ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: title
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
    onClick: onAction,
    disabled: disabled
  }, rest), children))) : /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 18
  })));
}
ActionIconButton.defaultProps = {
  busy: false,
  disabled: false
};
ActionIconButton.propTypes = {
  title: _propTypes.default.string.isRequired,
  onAction: _propTypes.default.func.isRequired,
  busy: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};